import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { makeSelectEntityStatuses } from "entities/entity_status";
import { makeSelectQuestionAnswerOptions } from "../questionAnswerOptions/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectLanguages } from "../languages";
import { makeSelectAnswerOptions } from "../answerOptions";

const selectEntity = state => state.entities.question;
const selectEntityFormat = state => state.entities.question_format;
const selectEntityData = state =>
  state.entities.question ? state.entities.question.data || {} : {};
const selectResources = state =>
  state.entities.question_resource_type
    ? state.entities.question_resource_type.data
    : {};

export const makeSelectQuestion = id =>
  createSelector([selectEntityData], substate => substate);

export const makeSelectAllQuestions = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectEntityStatuses(),
      makeSelectQuestionAnswerOptions(),
      makeSelectStringSource(),
      makeSelectTranslation(),
      makeSelectLanguages(),
      makeSelectAnswerOptions()
    ],
    (
      substate,
      page,
      entityStatuses,
      answers,
      resources,
      translations,
      languages,
      answerOptions
    ) => {
      if (!paginationKey) {
        const state = { ...substate };

        for (let key in state) {
          const question = { ...state[key] };

          //add status
          if (question.entity_status)
            question.entityStatus = entityStatuses[question.entity_status.id];

          //add resources if necessary
          if (resources && question.text) {
            for (let resource of resources) {
              if (resource.id === question.text.id) {
                question.text["string_resources"] = resource;
              }
            }
          }

          //add answers if necessary
          const answersArray = [];
          if (question.answer_options)
            for (let answer of question.answer_options) {
              answersArray.push(answerOptions[answer.id]);
            }
          question.answers = answersArray.filter(i => i);

          state[key] = question;
        }

        return state;
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            const question = { ...substate[id] };

            question.entityStatus = entityStatuses[question.entity_status.id];

            for (let resource of resources) {
              if (resource.id === question.text.id) {
                question.text["string_resources"] = resource;
              }
            }

            const answersArray = [];
            if (question.answer_options)
              for (let answer of question.answer_options) {
                answersArray.push(answerOptions[answer.id]);
              }
            question.answers = answersArray;

            /*
                  for (let resource of resources) {
                    for (let answer of question.answers){
                      if(resource.id === answer.string_resources.id)
                        answer.string_resources = resource

                    }
                  }
          */
            return question;
          })
          .filter(row => row);

      return [];
    }
  );

export const makeSelectIsQuestionLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });

export const makeSelectResources = () =>
  createSelector([selectResources], substate => substate);

export const makeSelectFormatIsLoading = () =>
  createSelector(selectEntityFormat, substate => {
    if (substate) return substate.loading;
  });
